<script setup lang="ts">
interface Props {
  aspect?: number
  index?: number
}

withDefaults(defineProps<Props>(), {
  aspect: 1,
  index: 0,
})
</script>

<template>
  <div class="skeleton rounded bg-gray opacity-20 w-full relative overflow-hidden">
    <div class="inset-0 absolute" />
  </div>
</template>

<style scoped>
.skeleton {
  aspect-ratio: v-bind(aspect);
}

.skeleton > div {
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.5) 50%, transparent 100%);
  background-size: 200% 100%;
  animation: shimmer 4s calc(v-bind(index) * 0.01s) infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
